export default {"src":"/_next/static/media/puzzle.620b3ec2.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};